/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Synthetic Button Component
 */

import { a11yButtonHandler } from '@zcode/nr/es/shared/utils/a11y'
import cn from '@zcode/nr/es/shared/utils/cn'
import React from 'react'

import css from './SyntheticButton.module.scss'

interface SyntheticButtonProps {
  children: React.ReactNode
  className: string
  onClick: () => void
  tabIndex?: number
}

export const SyntheticButton = React.forwardRef<HTMLSpanElement | null, SyntheticButtonProps>(
  ({ children, className, onClick, tabIndex = 0 }, ref) => {
    return (
      <span
        className={cn(className, css.syntheticButton)}
        onClick={onClick}
        onKeyPress={a11yButtonHandler(onClick)}
        ref={ref}
        role="button"
        tabIndex={tabIndex}
      >
        {children}
      </span>
    )
  }
)
